module.exports = __webpack_public_path__ + "img/hello-computer.cbc6601f.png";